import { useNavigate } from 'react-router';
import { Button, IconButton } from '@chakra-ui/react';
import { LuLogOut } from 'react-icons/lu';
import { useAuth } from '@/hooks/auth/useAuth';
import Tooltip from '@/components/Tooltip';

interface Props {
  isCollapsed?: boolean;
}

const Logout = ({ isCollapsed }: Props) => {
  const navigate = useNavigate();
  const { clearSession } = useAuth();

  const handleLogout = () => {
    clearSession();
    navigate('/', { replace: true });
  };

  if (isCollapsed) {
    return (
      <Tooltip content="Sair" positioning={{ placement: 'right' }} showArrow>
        <IconButton
          aria-label="Sair"
          size="sm"
          variant="ghost"
          width="full"
          _hover={{ bg: 'primary.50', color: 'primary.500' }}
          onClick={handleLogout}
        >
          <LuLogOut />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Button
      size="sm"
      onClick={handleLogout}
      variant="ghost"
      _hover={{
        bg: 'primary.50',
        color: 'primary.500',
      }}
    >
      <LuLogOut /> Sair
    </Button>
  );
};

export default Logout;
